import { render } from "./SplitCard.vue?vue&type=template&id=2733b93e&scoped=true"
import script from "./SplitCard.vue?vue&type=script&lang=js"
export * from "./SplitCard.vue?vue&type=script&lang=js"

import "./SplitCard.vue?vue&type=style&index=0&id=2733b93e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2733b93e"]])

export default __exports__